import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const checkSocialLinkURL = createAsyncThunk('checkSocialLinkURL/checkSocialLinkURL', async (data) => {
    try {
        const res = await axios({
            method: 'post',
            url: process.env.REACT_APP_API_URL + `check_social_linkurl`,
            data: {
                long_url: data.url
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return res
    } catch (error) {
        return error.response
    }
})

